import { useState } from 'react';
import useEffectOnce from './useEffectOnce';

export default function useNotification() {
  const [allowedNotification, setAllowNotification] = useState(false);

  useEffectOnce(() => {
    if ('Notification' in window) {
      // API supported
      Notification.requestPermission((permission) => {
        console.log('*** Notification request permission: ', permission);
        setAllowNotification(permission === 'granted');
      });
    }
  });

  return allowedNotification;
}
